/* eslint-disable react/prop-types */
import { Navigate } from "react-router-dom";
import useAuthorization from "~/hooks/useAuthorization";

const ProtectedRoute = ({ children, roles }) => {
  const userType = sessionStorage.getItem("role");
  const token = sessionStorage.getItem("loginToken");
  const checkPassword = sessionStorage.getItem("passwordType");
  // const userHasRequiredRole = roles?.includes(userType);

  const { userHasRequiredRole } = useAuthorization(roles);

  // Check if the user is authenticated
  if (!token) {
    // If not authenticated, redirect to the login page
    return <Navigate to="/authentication/sign-in" />;
  }
  if (checkPassword === "1" && token) {
    return <Navigate to="/change-password" />;
  }

  if (token && !userHasRequiredRole) {
    return <Navigate to="/dashboard" />;
  }

  return children;
};

export default ProtectedRoute;
